/* @flow weak */
import React from 'react';

import createFragment from 'react-addons-create-fragment';
import cx from 'classnames';

import styles from './styles/LeftRight.css';

/**
 * Layout component that encapsulates floating of elements to left, right, or both. Applies clearfix
 * to the container.
 *
 * ```example
 *  <LeftRight pull="both">
 *    <div>Hello from the left side.</div>
 *    <div>Hello from the right side.</div>
 *  </LeftRight>
 * ```
 *
 * ```example
 *  <LeftRight pull="left">
 *    <Glyph name="crown" color="sunrise" size="xxxlarge" style={{margin: 10}} />
 *    <div>
 *      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut eget tempus augue. Integer nec
 *      felis sollicitudin, egestas nisi vitae, egestas ex. Nam dictum pellentesque nunc, sed
 *      ultricies est efficitur rutrum. Mauris tempus malesuada fringilla. Sed augue nulla,
 *      fermentum vel euismod in, condimentum a tortor. Etiam commodo fringilla est non semper.
 *      Nullam non ornare tortor. Morbi elit leo, venenatis a vehicula non, blandit a nunc.
 *      Curabitur diam metus, elementum eu placerat nec, varius id lorem.
 *    </div>
 *  </LeftRight>
 * ```
 */

class LeftRight extends React.Component {
  static propTypes = {
    /** Child element to float */
    pull: React.PropTypes.oneOf(['left', 'right', 'both']),
    children(props, propName) {
      if (React.Children.count(props[propName]) !== 2) {
        return new Error('FlexibleBlock expects two child elements');
      }
    },
  };

  static defaultProps = {
    pull: 'both',
  };

  clone = (node, className) => {
    const wrappedNode = this.wrap(node);
    return React.cloneElement(wrappedNode, {
      className: cx(wrappedNode.props.className, className),
    });
  };

  wrap = (node) => {
    if (React.isValidElement(node)) {
      return node;
    }
    return <div>{node}</div>;
  };

  render() {
    const [left, right] = this.props.children;

    let children;
    const { pull } = this.props;
    if (pull === 'right') {
      children = createFragment({
        right: this.clone(right, styles.pullRight),
        left: this.wrap(left),
      });
    } else {
      children = createFragment({
        left: this.clone(left, styles.pullLeft),
        right: pull === 'both' ? this.clone(right, styles.pullRight) : this.wrap(right),
      });
    }

    return (
      <div className={cx(styles.this, this.props.className)}>
        {children}
      </div>
    );
  }
}

export default LeftRight;



// WEBPACK FOOTER //
// ./src/components/LeftRight.jsx